import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import userApply from '@/components/userApply'
import Welcome from '@/components/Welcome'
import ReleaseHistory from '../components/ReleaseHistory.vue'

Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/logout',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      // beforeEnter: (to, from, next) => {
      //   if (sessionStorage.getItem('token') !== null) {
      //     console.log('fromGGPS')
      //     sessionStorage.setItem('fromGGPS', true)
      //   }
      //   next()
      // }
    },
    {
      path: '/userApply',
      name: 'userApply',
      component: userApply,
      beforeEnter: (to, from, next) => {
        // let obj = JSON.parse(sessionStorage.getItem('workingApplication'))
        // if (to.fullPath === '/userApply' && sessionStorage.getItem('token')) {
        //   console.log('fromGGPS')
        //   sessionStorage.setItem('fromGGPS', true)
        // }
        if (to.fullPath === '/userApply' && from.fullPath === '/') {
          sessionStorage.setItem('refreshed', true)
        }
        next()
      },
    },
    {
      path: '/releases',
      name: 'ReleaseHistory',
      component: ReleaseHistory,
    },
  ],
})

router.beforeEach((to, from, next) => {
  // if (!JSON.parse(sessionStorage.getItem('currentUser')) && to.fullPath !== '/login') {
  //   return next('/login')
  // }
  // if (to.fullPath === '/userApply' && from.fullPath === '/') {
  // }
  // console.log(to, from)
  if (to.fullPath === '/prod/exUser/' && from.fullPath === '/') {
    sessionStorage.setItem('fromGGPS', true)
    return next('/login')
  } else if (to.fullPath === '/prod/exUser/#/login' && from.fullPath === '/') {
    sessionStorage.setItem('fromGGPS', false)
    return next('/login')
  } else if (to.fullPath === '/prod/pilot/' && from.fullPath === '/') {
    sessionStorage.setItem('fromGGPS', false)
    return next('/login')
  } else if (to.fullPath === '/' && from.fullPath === '/') {
    sessionStorage.clear()
    return next('/login')
  } else if (to.fullPath === '/' && from.fullPath === '/userApply') {
    return next('/userApply')
  }
  return next()
})

export default router
